<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base__title mb-4">
        Прошу нотариуса совершить перевод и засвидетельствовать его верность
        удаленно
      </div>
      <div class="form-base">
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="$v.correctTranslationDetails.languageFrom.$model"
              label="Язык, с которого совершается перевод"
              no-data-text="Нет данных"
              outlined
              item-text="title"
              item-value="code"
              return-object
              :errorMessages="
                getValidationErrorText(
                  $v.correctTranslationDetails.languageFrom
                )
              "
              :items="languages"
              :filter="filterLanguage"
              :loading="languagesLoading"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="$v.correctTranslationDetails.languageTo.$model"
              label="Язык, на который совершается перевод"
              no-data-text="Нет данных"
              outlined
              item-text="title"
              item-value="code"
              return-object
              :errorMessages="
                getValidationErrorText($v.correctTranslationDetails.languageTo)
              "
              :items="languages"
              :filter="filterLanguage"
              :loading="languagesLoading"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model.trim="$v.translatedDocument.name.$model"
              :errorMessages="
                getValidationErrorText($v.translatedDocument.name)
              "
              label="Наименование документа, подлежащего переводу"
              outlined
            />
          </v-col>
        </v-row>

        <AttachDocumentSingle
          @change="
            $v.translatedDocument.file.$model = $event.file;
            $v.translatedDocument.fileSig.$model = $event.fileSig;
          "
          :value="{
            file: $v.translatedDocument.file.$model,
            fileSig: $v.translatedDocument.fileSig.$model,
          }"
          :error-messages="getValidationErrorText($v.translatedDocument.file)"
        />
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import Footer from '@/components/services/elements/Footer';
import { LanguagesModule } from '@/store/modules/languages';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import { checkInvalid, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import { StepDirection, StepName } from '@/types/services';
import { CorrectTranslationStep } from '@/constants';

const translatedDocumentModel = {
  name: '',
  file: null,
  fileSig: null,
};

export default {
  name: 'TranslatedDocument',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    AttachDocumentSingle,
  },
  data() {
    return {
      StepDirection,
      StepName,
      leaveStep,
      getValidationErrorText,
      invalidFields: [],
      correctTranslationDetails: {
        languageFrom: null,
        languageTo: null,
      },
      translatedDocument: cloneDeep(translatedDocumentModel),
    };
  },
  validations: {
    correctTranslationDetails: {
      languageFrom: {
        required: requiredIf((vm) => {
          return Boolean(!(vm.languageFrom?.code && vm.languageFrom?.title));
        }),
      },
      languageTo: {
        required: requiredIf((vm) => {
          return Boolean(!(vm.languageTo?.code && vm.languageTo?.title));
        }),
      },
    },
    translatedDocument: {
      name: {
        required,
        maxLength: maxLength(1000),
        EMOJI,
      },
      file: {
        DOCUMENTS_MIN_LENGTH: required,
      },
      fileSig: {
        DOCUMENTS_MIN_LENGTH: required,
      },
    },
  },
  computed: {
    languages() {
      return LanguagesModule.entities;
    },

    languagesLoading() {
      return LanguagesModule.loading;
    },
  },
  created() {
    this.prefillDraft();
    this.getData();
  },
  methods: {
    filterLanguage(item, queryText) {
      return (
        item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1
      );
    },

    getData() {
      if (!LanguagesModule.loading && !LanguagesModule.loaded) {
        LanguagesModule.fetch();
      }
    },

    prefillDraft() {
      if (!ServicesModule.statement.correctTranslationDetails) {
        return;
      }

      this.correctTranslationDetails = cloneDeep(
        ServicesModule.statement.correctTranslationDetails
      );
      this.translatedDocument = cloneDeep(
        ServicesModule.statement.translatedDocument || translatedDocumentModel
      );
    },

    assemblyModel() {
      return {
        correctTranslationDetails: cloneDeep(this.correctTranslationDetails),
        translatedDocument: cloneDeep(this.translatedDocument),
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: CorrectTranslationStep.TRANSLATED_DOCUMENT,
      });
    },
  },
};
</script>
